'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')
//var MapModule = require('src/common/mapSimple')
var MapRadiusModule = require('src/common/mapRadius')

var DialogComponent = require('src/components/dialog-view')

// -- Dialog Body ---------------------------
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/emergency.html'),
  events: {
    'change .js-radius-select': 'onValueChange'    
  },
  modelEvents: {
    'change': 'modelChange'
  },
  initialize: function () {
    var self = this

    this.model.set('location', [52.0898090, 5.1063840])

    if (navigator.geolocation) {
    //  navigator.geolocation.getCurrentPosition(_.bind(this.showPosition, self))
    } else {
      console.log('Geolocation is not supported by this browser.')
    }
  // navigator.geolocation.getCurrentPosition(showPosition)
  },
  modelChange: function () {
    var location = this.model.get('location')
    var radius = this.model.get('radius')

    this.editMap.setRadiusIndicator(location, radius)
    this.editMap.setLocationMarker(location)
  },
  onValueChange: function (ev) {
    this.model.set('radius', ev.currentTarget.value)
  },
  showPosition: function (position) {
    this.model.set('location', [position.coords.latitude, position.coords.longitude])

    this.editMap.setPosition(this.model.get('location'))
    this.editMap.setMarkerPosition('emergencyMarker', this.model.get('location'))
  },
  onPresetChange: function (ev) {
    this.triggerMethod('dialog:load-preset', this, ev.currentTarget.value)
  },
  onDomRefresh: function () {
    console.log('refresh')
    var self = this
    setTimeout(function () {
     var location = self.model.get('location')

     // map
      self.editMap = new MapRadiusModule({
        'container': 'editMap',
        'location': location,
        'zoomLevel': 18
      })

      self.editMap.setRadiusIndicator(location, 0)

      var onDragEnd = function (event) {
        var marker = event.target // you could also simply access the marker through the closure
        var result = marker.getLatLng() // but using the passed event is cleaner
        self.model.set('location', [result.lat, result.lng])
      }

      self.editMap.createLocationMarker(location, onDragEnd)

    }, 0)
  },
  templateContext: function () {
    var self = this
    return {

    }
  }
})

// -- Dialog Layout ---------------------------
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-device-edit',
  childViewTriggers: {},
  modelEvents: {
  //  'change': 'render' // disabled because it triggered a massive refresh
  },
  onRender: function () {
    var bodyView = new DialogBody(this.options)
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/devices/emergency/view.js